import React from "react";
import FinancingRequestStudentData from "../../../models/financing-request/student-data/FinancingRequestStudentData";
import StepHandler from "../../../models/shared/StepHandler";
import TrTableHeadMetadata from "../../../models/shared/TrTableHeadMetadata";
import TrTable from "../../shared/controls/TrTable";
import TrTableBodyData from "../../../models/shared/TrTableBodyData";
import { Paper, Typography } from "@material-ui/core";
import { hrDate } from "../../../utilities/utilities";
import { ProgramType } from "../../../models/financing-request/ProgramType";

interface Props extends StepHandler {
  studentsData: FinancingRequestStudentData[];
}

interface StudentsDataStudent {
  studentId: number;
  name: string;
  birthDate: Date;
  oib: string;
  schoolClass: string;
  sectionMark: string;
  sectionTypeName: string;
  programName: string;
  transportOption: string;
  foodOption: string;
  teachingAidOption: string;
}

export default function FinancingRequestDataConfirmationStep({
  buttons,
  onPrevious,
  onNext,
  goToPreviousStep,
  goToNextStep,
  onStepperSave,
  studentsData
}: Props) {
  let studentsDataStudents = new Array<StudentsDataStudent>();

  studentsData.forEach(studentData => {
    studentsDataStudents.push({
      studentId: studentData.student.id,
      name: studentData.student.lastName + " " + studentData.student.firstName,
      birthDate: studentData.student.birthDate,
      oib: studentData.student.oib,
      schoolClass: studentData.student.schoolClass,
      sectionMark: studentData.student.sectionMark,
      sectionTypeName: studentData.student.sectionTypeName,
      programName: studentData.student.programName,
      transportOption: studentData.transportOptionInfo || "-",
      foodOption: studentData.foodOptionInfo || "-",
      teachingAidOption: studentData.teachingAidOptionInfo || "-"
    });
  });

  const hasElementary =
    studentsData.filter(
      studentData => studentData.student.programType == ProgramType.Elementary
    ).length > 0;

  let tableHeadMetadata: TrTableHeadMetadata<StudentsDataStudent>[];
  if (hasElementary) {
    tableHeadMetadata = [
      {
        id: "studentName",
        label: "Učenik",
        dataName: "name",
        dataFunc: (d: StudentsDataStudent) => (
          <>
            <Typography variant="body2">{d.name}</Typography>
            <Typography variant="body2">{hrDate(d.birthDate)}</Typography>
          </>
        )
      },
      { id: "oib", label: "OIB", dataName: "oib" },
      {
        id: "schoolClass",
        label: "Razred",
        dataName: "schoolClass",
        dataFunc: (d: StudentsDataStudent) => (
          <>
            <Typography variant="body2">{d.programName}</Typography>
            <Typography variant="body2">
              {d.schoolClass + " - " + d.sectionMark}
            </Typography>
          </>
        )
      },
      {
        id: "vrstaOdjeljenja",
        label: "Vrsta odjeljenja",
        dataFunc: (d: StudentsDataStudent) => (
          <Typography variant="body2">{d.sectionTypeName}</Typography>
        )
      },
      { id: "transportOption", label: "Prijevoz", dataName: "transportOption" },
      { id: "foodOption", label: "Prehrana", dataName: "foodOption" },
      {
        id: "teachingAidOption",
        label: "Posebna nastavna sredstva i pomagala",
        dataName: "teachingAidOption"
      }
    ];
  } else {
    tableHeadMetadata = [
      {
        id: "studentName",
        label: "Učenik",
        dataName: "name",
        dataFunc: (d: StudentsDataStudent) => (
          <>
            <Typography variant="body2">{d.name}</Typography>
            <Typography variant="body2">{hrDate(d.birthDate)}</Typography>
          </>
        )
      },
      { id: "oib", label: "OIB", dataName: "oib" },
      {
        id: "schoolClass",
        label: "Razred",
        dataName: "schoolClass",
        dataFunc: (d: StudentsDataStudent) => (
          <>
            <Typography variant="body2">{d.programName}</Typography>
            <Typography variant="body2">
              {d.schoolClass + " - " + d.sectionMark}
            </Typography>
          </>
        )
      },
      {
        id: "vrstaOdjeljenja",
        label: "Vrsta odjeljenja",
        dataFunc: (d: StudentsDataStudent) => (
          <Typography variant="body2">{d.sectionTypeName}</Typography>
        )
      },
      { id: "transportOption", label: "Prijevoz", dataName: "transportOption" },
      {
        id: "teachingAidOption",
        label: "Posebna nastavna sredstva i pomagala",
        dataName: "teachingAidOption"
      }
    ];
  }

  const tableBodyData: TrTableBodyData = {
    idDataName: "studentId",
    data: studentsDataStudents
  };

  const handlePreviousStep = () => {
    if (goToPreviousStep != null) {
      goToPreviousStep();
    }
  };

  const handleNextStep = () => {
    if (goToNextStep != null) {
      goToNextStep();
    }
  };

  const handleUpdateState = () => {};

  onPrevious && onPrevious(handlePreviousStep);
  onNext && onNext(handleNextStep);
  onStepperSave && onStepperSave(handleUpdateState);

  return (
    <>
      <Paper>
        <TrTable
          headMetadata={tableHeadMetadata}
          bodyData={tableBodyData}
          enableSelect={false}
        />
      </Paper>
      {buttons}
    </>
  );
}
